const POSITION_ORDER = ['GOALKEEPER', 'DEFENDER', 'MIDFIELDER', 'WINGER', 'FORWARD', 'FLEXIBLE'];

const POSITION_LABELS = {
  GOALKEEPER: 'Goalkeeper',
  DEFENDER: 'Defenders',
  MIDFIELDER: 'Midfielders',
  WINGER: 'Wingers',
  FORWARD: 'Forwards',
  FLEXIBLE: 'Flexible',
};

const POSITION_ABBR = {
  GOALKEEPER: 'GK',
  DEFENDER: 'DEF',
  MIDFIELDER: 'MID',
  FORWARD: 'FWD',
  WINGER: 'WNG',
  FLEXIBLE: 'FLX',
};

export const getPositionAbbreviation = (position) => POSITION_ABBR[position] || 'FLX';

export const getPositionLabel = (position) =>
  POSITION_LABELS[position] || (position || 'Flexible').replace(/_/g, ' ').toLowerCase();

export const groupPlayersByPosition = (players = []) => {
  const groups = {};
  players.forEach((player) => {
    const key = player.position || 'FLEXIBLE';
    if (!groups[key]) groups[key] = [];
    groups[key].push(player);
  });

  return POSITION_ORDER.filter((key) => groups[key]?.length > 0).map((key) => ({
    position: key,
    label: getPositionLabel(key),
    players: [...groups[key]].sort((a, b) =>
      (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
    ),
  }));
};

export const getTeamDisplayName = (division) => {
  if (!division?.teamName) return 'Team';
  if (division.teamName.includes('Red') || division.teamName.includes('🔴')) return 'Red Team';
  if (division.teamName.includes('Blue') || division.teamName.includes('🔵')) return 'Blue Team';
  return division.teamName.replace('🔴 ', '').replace('🔵 ', '');
};

export const getTeamAccent = (division) => {
  const name = division?.teamName || '';
  if (name.includes('Red') || name.includes('🔴')) {
    return { color: '#dc3545', bg: '#fff5f5', border: '#f5c2c7' };
  }
  if (name.includes('Blue') || name.includes('🔵')) {
    return { color: '#0d6efd', bg: '#f0f8ff', border: '#b6d4fe' };
  }
  return { color: '#495057', bg: '#f8f9fa', border: '#dee2e6' };
};
